<template>
  <div class="container">
    <img src="../assets/minipoetryapp.png">
    <div class="button-box">
      <button type="button" name="button" @click="download">Android下载</button>
    </div>
    <div class="mask" v-if="showTips"></div>
    <div class="bubble" v-if="showTips">
      <div class="talk">请点击右上角<br>选择"浏览器中打开"</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showTips: false
    }
  },
  methods: {
    download() {
      var url = 'http://s.xingzou.art/app/minipoetryapp.apk';
      // 判断是否在微信中打开，如果是，则提示打开浏览器下载
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf('micromessenger') >= 0;
      var isQQ = ua.indexOf('qq') >= 0;
      if (!isWeixin && !isQQ) {
        window.location.href = url;
      } else {
        document.title = '下载';
        this.showTips = true;
      }
    }
  },
}
</script>

<style lang="less" scoped>
.container {
  width: 100vw;
  height: 100vh;

  img {
    width: 100%;
    border: none;
  }
  .button-box {
    position: fixed;
    bottom: 72px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      position: relative;
      display: inline-block;
      box-sizing: border-box;
      height: 44px;
      margin: 0;
      padding: 0 24px;
      font-size: 14px;
      line-height: 1.2;
      text-align: center;
      border-radius: 44px;
      cursor: pointer;
      -webkit-transition: opacity 0.2s;
      transition: opacity 0.2s;
      -webkit-appearance: none;
      color: #fff;
      background-color: #FF5722;
      border: 1px solid #FF5722;
      box-shadow: 6px 6px 10px #888888;
    }
    button:focus,
    button:active:focus,
    button.active:focus,
    button.focus,
    button:active.focus,
    button.active.focus {
      outline: none;
      border-color: transparent;
      box-shadow: none;
    }
  }

  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .bubble {
    position: fixed;
    top: 22px;
    right: 6px;
    border-radius: 5px;
    color: #ddd;
    background-color: rgb(192, 72, 81);
    font-size: 14px;

    .talk {
      padding: 12px;
      color: #FFFFFF;
      text-align: center;
    }
  }
  .bubble:after{content:'';position:absolute;bottom:100%;right:0px;width:16px;height:16px;border-width:0;border-style:solid;border-color:transparent;border-left-width:10px;border-left-color:currentColor;border-radius:32px 0 0 0;color:#C04851;}
}
</style>
